import {
  PRICE_REQUEST_STATUS_MAP,
  PriceRequestStatus
} from './priceRequestStatus';

export const mapPrStatus = (priceRequestStatus: PriceRequestStatus): string => {
  return PRICE_REQUEST_STATUS_MAP.get(priceRequestStatus) || priceRequestStatus;
};
